import {Component} from 'react';
import ReactDOM from 'react-dom';

export default class Portal extends Component
{
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.root = document.getElementById(this.props.id);
  }

  componentDidMount() {
    if(this.root)
    {
      this.root.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    if(this.root)
    {
      this.root.removeChild(this.el);
    }
  }

  render()
  {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

